import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import RenderOptions from "containers/request/RequestList/RenderOptions";
import ListTable from "containers/request/RequestList/RequestListTable";
import {
  Pager,
  PagerPageSize,
  PagerStatusFilter,
  Divider,
  CounterLabel
} from "ctia-ui";
import { Col, Row } from "react-bootstrap";
import { fetchCertificationRequests, clearRequests } from "actions/requests";
import { setPageSize, changeCyberRequestStatus } from "actions/app";
import CyberTable from "containers/CyberTable";
import {
  blcOptions,
  cyberOptions
} from "containers/request/RequestList/statusOptions";
import RequestListTitle from "containers/request/RequestList/RequestListTitle";

class RequestList extends CyberTable {
  startPage = this.props.app.pageSize === 0 ? 0 : 1;

  componentWillUnmount() {
    this.props.clearRequests();
  }

  onStatusChange = event => {
    const newStatus = Number(event.target.value);

    // update app filter settings
    this.props.changeCyberRequestStatus(newStatus);

    // fetch new list (waiting for redux storage update first)
    setTimeout(this.fetchTableData, 150);
  };

  fetchTableData = (
    pageNum = this.startPage,
    statusFilter = this.props.app.cyberRequestStatus.filter,
    pageSize = this.props.app.pageSize
  ) => this.props.fetchCertificationRequests(pageNum, pageSize, statusFilter);

  setPagerSize = size => this.props.setPageSize(size);

  render() {
    const { requests, app } = this.props;
    const { cyberRequestStatus } = app;
    const tableData = this.setTableData(requests);
    const { page, pages, records } = this.setPagerData(requests);
    const counter = this.setCounter(tableData, records);
    const sortedFilterOptions = app.isBLCCert
      ? _.sortBy(blcOptions, ["title", "id"])
      : _.sortBy(cyberOptions, ["title", "id"]);
    const isBLC = app.isBLCCert;

    return (
      <div>
        <RequestListTitle listLabel={cyberRequestStatus.title} />
        <Row>
          <div id="request-filter">
            <Col xs={4} md={4}>
              <CounterLabel counter={counter} />
            </Col>
            <Col xs={8} md={4}>
              <PagerPageSize
                size={app.pageSize}
                onChangeHandler={this.onChangePageSize}
                options={[50, 100]}
                showAll={true}
              />
            </Col>
            <Col xs={12} md={4}>
              <PagerStatusFilter
                status={cyberRequestStatus.id}
                statusOptions={<RenderOptions options={sortedFilterOptions} />}
                onStatusChange={this.onStatusChange}
              />
            </Col>
          </div>
        </Row>

        <ListTable data={tableData} fetchHandler={this.fetchTableData} isBLC={isBLC}/>
        <Divider />
        <Pager moveTo={this.fetchTableData} totalPages={pages} page={page} />
      </div>
    );
  }
}

function mapStateToProps({ requests, app }) {
  return { requests, app };
}

export default connect(mapStateToProps, {
  setPageSize,
  changeCyberRequestStatus,
  fetchCertificationRequests,
  clearRequests
})(RequestList);
